import { Circle } from "lucide-react";

function formatLastSeen(iso) {
  if (!iso) return "Desconectado";
  const then = new Date(iso);
  const now = new Date();
  const diffMin = Math.floor((now - then) / 60000);
  if (diffMin < 1) return "Últ. vez hace instantes";
  if (diffMin < 60) return `Últ. vez hace ${diffMin} min`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return `Últ. vez hace ${diffH} h`;
  const sameYear = then.getFullYear() === now.getFullYear();
  const opts = sameYear
    ? { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }
    : { day: "2-digit", month: "short", year: "numeric" };
  return `Últ. vez ${then.toLocaleDateString(undefined, opts)}`;
}

export function PresenceDot({ isOnline, size = 10, className = "" }) {
  return (
    <span
      className={
        "inline-block rounded-full border-2 border-[#0F172A] " + className
      }
      style={{
        width: size,
        height: size,
        background: isOnline ? "#22c55e" : "#64748b",
        boxShadow: isOnline ? "0 0 8px rgba(34,197,94,0.6)" : "none",
      }}
      aria-hidden="true"
    />
  );
}

export function PresenceText({ isOnline, lastSeen, className = "" }) {
  if (isOnline) {
    return (
      <span
        className={"inline-flex items-center gap-1.5 text-xs font-medium " + className}
        style={{ color: "#4ade80" }}
      >
        <Circle size={7} fill="#22c55e" strokeWidth={0} /> En línea
      </span>
    );
  }
  return (
    <span className={"text-xs text-slate-400 " + className}>
      {formatLastSeen(lastSeen)}
    </span>
  );
}
